import { render, staticRenderFns } from "./InfoMessageCreateModal.vue?vue&type=template&id=4a97aa3e&scoped=true"
import script from "./InfoMessageCreateModal.vue?vue&type=script&lang=js"
export * from "./InfoMessageCreateModal.vue?vue&type=script&lang=js"
import style0 from "./InfoMessageCreateModal.vue?vue&type=style&index=0&id=4a97aa3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97aa3e",
  null
  
)

export default component.exports